// import { staffClient } from 'common/apis/staff';
import axios from 'axios';

export namespace FileUtils {
    export const uploadS3File = async (file: File, url: string) => {
        try {
            const uploadResponse = await axios.put(url, file, {
                headers: {
                    'Content-Type': file.type
                }
            });

            if (uploadResponse.status === 200) {
                // insertToEditor(url.split('?')[0]);
                return url.split('?')[0];
            } else {
                console.error('Failed to upload image.');
            }
        } catch (error) {
            console.error('An error occurred during the image upload process:', error);
        }
    }

    export const getFileHash = async (file) => {
        const fileContent = await file.arrayBuffer();
        const hashBuffer = await crypto.subtle.digest('SHA-256', fileContent);
        const hashArray = Array.from(new Uint8Array(hashBuffer));
        const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
        return hashHex;
    }

    export const checkFileSize = (file, maxFileSizeMb) => {
        console.log('[checkFileSize] file size', file.size, maxFileSizeMb);
        const maxFileSize = maxFileSizeMb * 1024 * 1024;
        if (file.size > maxFileSize) {
            alert(`${file.name} 파일의 크기가 ${maxFileSizeMb}MB를 초과했습니다.`);
            return false;
        }
        return true;
    };

    export const selectFiles = async (isImg = false, isMultiple = true) => {
        return new Promise((resolve, reject) => {
            const input = document.createElement('input');
            input.setAttribute('type', 'file');
            if(isImg) {
                input.setAttribute('accept', 'image/*');
            }
            if(isMultiple){
                input.setAttribute('multiple', 'multiple');
            }
            input.click();
            input.onchange = () => {
                const files = Array.from(input.files);
                if (files.length > 0) {
                    resolve(files);
                } else {
                    reject('No files selected');
                }
            };
            input.onerror = () => {
                reject('Error selecting files');
            };
        });
    }

    export const checkIsImage = (file: File) => {
        return file.type.includes('image');
    }

    export const downloadFile = async (url: string, filename: string) => {
        try {
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error('Failed to fetch the file');
            }
            const blob = await response.blob();
            const blobUrl = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = blobUrl;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(blobUrl);
        } catch (error) {
            console.error('Download failed:', error);
        }
    };
    

}
